/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
export const GETSUBSCRIPTION_HOMEPAGE_REQUEST =
  "GETSUBSCRIPTION_HOMEPAGE_REQUEST";
export const GETSUBSCRIPTION_HOMEPAGE_SUCCESS =
  "GETSUBSCRIPTION_HOMEPAGE_SUCCESS";
export const GETSUBSCRIPTION_HOMEPAGE_FAILURE =
  "GETSUBSCRIPTION_HOMEPAGE_FAILURE";
